import { fadeIn, fadeOut } from '../core/animation'

export default function init() {
  const html = document.documentElement
  const body = document.body
  const burger = document.querySelector('.burger')
  const canvasClose = document.querySelector('.canvas-close')
  const dimmer = document.querySelector('.dimmer')
  if (!burger) return

  burger.addEventListener('click', function () {
    html.classList.toggle('canvas-opened')
    html.classList.add('canvas-visible')
    fade(dimmer, 'open')
  })

  canvasClose.addEventListener('click', function () {
    if (html.classList.contains('canvas-opened')) {
      html.classList.remove('canvas-opened')
      fade(dimmer, 'close')
    }
  })

  dimmer.addEventListener('click', function () {
    if (html.classList.contains('canvas-opened')) {
      html.classList.remove('canvas-opened')
      fade(dimmer, 'close')
    }
  })

  body.addEventListener('keydown', (ev) => {
    if (
      (ev.key === 'Escape' || ev.code === 'Escape') &&
      html.classList.contains('canvas-opened')
    ) {
      html.classList.remove('canvas-opened')
      fade(dimmer, 'close')
    }
  })
}

function fade(el, action) {
  switch (action) {
    case 'open':
      fadeIn(el)
      break
    case 'close':
      fadeOut(el)
      break
  }
}
